document.addEventListener("DOMContentLoaded", function () {
    const productJson = document.querySelector('[id^="ProductJson-"]');
  
    if (!productJson) {
      console.error("Bloc JSON du produit introuvable.");
      return;
    }
  
    let productData;
  
    try {
      productData = JSON.parse(productJson.textContent);
    } catch (e) {
      console.error("Erreur lors du parsing JSON du produit :", e);
      return;
    }
  
    const variants = productData.variants;
    console.log("Variantes disponibles :", variants);
  
    const form = document.querySelector("[data-product-form]");
    const selectors = form.querySelectorAll("select.single-option-selector"); // Sélectionner uniquement les selects
  
    function findMatchingVariant() {
      const selectedOptions = Array.from(selectors).map(select => select.value);
      const matchedVariant = variants.find(variant => {
        return variant.options.every((opt, index) => opt === selectedOptions[index]);
      });
  
      return matchedVariant;
    }
  
    // Met à jour le champ hidden ID selon la variante sélectionnée
    function updateVariantId() {
      const matchedVariant = findMatchingVariant();
      if (matchedVariant) {
        const variantSelect = form.querySelector("select[name='id']");
        variantSelect.value = matchedVariant.id;
        console.log("ID de variante mis à jour :", matchedVariant.id);
      }
    }
  
    // Écoute les changements sur les selects
    selectors.forEach(select => {
      select.addEventListener("change", updateVariantId);
    });
  
    // Synchronise les inputs radios avec les selects
    const radios = form.querySelectorAll('input[type="radio"]');
  
    radios.forEach(radio => {
      radio.addEventListener("change", (e) => {
        const radioInput = e.target;
        const optionIndex = radioInput.name.replace('option-', ''); // Extraire l'index de l'option
        const value = radioInput.value;
  
        // Trouver le <select> correspondant
        const select = form.querySelector(`select[data-index="option${parseInt(optionIndex) + 1}"]`);
        if (select) {
          select.value = value; // Mettre à jour la valeur du select
          select.dispatchEvent(new Event('change', { bubbles: true })); // Déclencher l'événement 'change'
        }
      });
    });
});
